<template>
  <b-popover
    :placement="placement"
    :custom-class="`al-contextual-menu-body ${position}`"
    :target="target"
    test-id="al-popover"
  >
    <slot />
  </b-popover>
</template>

<script>
import { BPopover } from 'bootstrap-vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BPopover
  },
  props: {
    target: {
      type: String,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: ''
    }
  }
};
</script>
